'use client';

var FILE_UPLOAD_SIZE = 5120000;
var LOADING_STATUS = 2;
var FAIL_STATUS = 1;
var SUCCESS_STATUS = 3;
var INIT_STATUS = -1;

export { FAIL_STATUS, FILE_UPLOAD_SIZE, INIT_STATUS, LOADING_STATUS, SUCCESS_STATUS };
//# sourceMappingURL=constants.js.map
